(function () {
  const MODE_INSPIRE = 'inspire';
  const MODE_BUY = 'buy';
  const VALID_MODES = [MODE_INSPIRE, MODE_BUY];

  function normalizeMode(mode) {
    return VALID_MODES.includes(mode) ? mode : MODE_INSPIRE;
  }

  function initHeaderNavMode(root) {
    if (!root || root.dataset.headerNavModeInitialized === 'true') return;

    const section = root.closest('.shopify-section') || root.parentElement;
    if (!section) return;

    const tabs = Array.from(section.querySelectorAll('[data-header-nav-mode]'));
    const cards = Array.from(section.querySelectorAll('[data-header-nav-card]'));
    if (!tabs.length) return;

    const setMode = function (requestedMode, focusActiveTab) {
      const mode = normalizeMode(requestedMode);
      root.dataset.headerNavActiveMode = mode;

      tabs.forEach(function (tab) {
        const isActive = tab.dataset.headerNavMode === mode;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      cards.forEach(function (card) {
        const buyUrl = card.dataset.headerNavBuyUrl || '#';
        const inspireUrl = card.dataset.headerNavInspireUrl || buyUrl;
        card.setAttribute('href', mode === MODE_INSPIRE ? inspireUrl : buyUrl);
      });

      if (focusActiveTab) {
        const activeTab = tabs.find(function (tab) {
          return tab.dataset.headerNavMode === mode;
        });
        activeTab?.focus();
      }
    };

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setMode(tab.dataset.headerNavMode, false);
      });

      tab.addEventListener('keydown', function (event) {
        const currentIndex = VALID_MODES.indexOf(normalizeMode(root.dataset.headerNavActiveMode));
        let nextIndex = currentIndex;

        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (currentIndex - 1 + VALID_MODES.length) % VALID_MODES.length;
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (currentIndex + 1) % VALID_MODES.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = VALID_MODES.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        setMode(VALID_MODES[nextIndex], true);
      });
    });

    root.dataset.headerNavModeInitialized = 'true';
    setMode(root.dataset.headerNavDefaultMode, false);
  }

  function initAll(scope) {
    const context = scope || document;
    context.querySelectorAll('[data-header-nav-root]').forEach(initHeaderNavMode);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

